export enum LoyaltyProgramPromosTypes {
  Discount = 'discount',
  Point = 'points'
}

export interface ILoyaltyProgramBirthdayOptions {
  shouldCollect: boolean;
  shouldSendMessage: boolean;
  greetingMessage?: string;
  promoValue?: number;
  promoLimitedTo?: Array<string>;
}

export interface ILoyaltyProgramDiscountOptions {
  numberOfAppointments: number;
  promoLimitedTo?: Array<string>;
  discountAmount: number;
}

export interface ILoyaltyProgramPointsOptions {
  percentageToGather: number;
  pointName: string;
}

export interface ILoyaltyProgram {
  bid: string;
  promoType: LoyaltyProgramPromosTypes;
  birthday: ILoyaltyProgramBirthdayOptions;
  pointsOptions?: ILoyaltyProgramPointsOptions;
  discountOptions?: ILoyaltyProgramDiscountOptions;
  /**
   * Channel for the club invite and welcome messages. Saved with the program settings but
   * stored on the business (`configurations.loyaltyMessagesChannel`), where the senders read it.
   */
  messagesChannel?: 'sms' | 'whatsapp';
}

export interface IJoinLoyaltyDto {
  bid: string;
  customerId: string;
  /** Omitted when the program doesn't collect birthdays. */
  birthday?: string;
}

export interface ILoyaltyProgramMember {
  id: string;
  name: string;
  joinedAt?: Date | string;
  birthday?: Date | string;
}
